import { drawingStore } from "../store";

export const setDrawingsOverlay = (overlay: google.maps.MapType) => {
  drawingStore.drawingsOverlay = overlay;
};
